import { API_DOMAIN } from 'constants/infograph';
import request from 'utils/request';

export type Icons8Params = {
  category?: string;
  platform: string;
  limit: number;
  offset: number;
};

type Icons8IconData = {
  id: string;
  name: string;
  commonName: string;
  platform: string;
};

export type Icons8IconsApiResponse = {
  success: boolean;
  icons: Icons8IconData[];
  parameters: {
    amount: number;
    countAll: number;
    offset: number;
  };
};

// fetch api from
export const fetchE2Icons8Api = async (param: Icons8Params, token: string) => {
  const { category, platform, limit, offset } = param;

  const queryParams = new URLSearchParams({
    category: category || '',
    platform,
    limit: limit.toString(),
    offset: offset.toString(),
  });

  let requestURL = `${API_DOMAIN}/searchIcons8?${queryParams.toString()}`;

  const headers = new Headers({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  });

  return await request<Icons8IconsApiResponse>(requestURL, {
    method: 'GET',
    headers: Object.fromEntries(headers),
  });
};

export type Icons8IllustrationParams = {
  categories: string;
  style: string;
  page: number;
  perPage: number;
};

type Icons8IllustrationData = {
  id: string;
  mediaResources: string[];
  urls: {
    thumb: { url: string; width: number; height: number };
  };
};

export type Icons8IllustrationResponse = {
  illustrations: Icons8IllustrationData[];
  total: number;
};
/**
 * Fetch Icons8 Illustrations of specified style and category
 *
 * @param param
 * @param token
 * @returns
 */
export const listIcons8Illustrations = async (param: Icons8IllustrationParams, token: string) => {
  const { categories, style, page, perPage } = param;

  const queryParams = new URLSearchParams({
    categories,
    style: style,
    page: page.toString(),
    perPage: perPage.toString(),
  });

  let requestURL = `${API_DOMAIN}/listIcons8Illustrations?${queryParams.toString()}`;

  const headers = new Headers({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  });

  return await request<Icons8IllustrationResponse>(requestURL, {
    method: 'GET',
    headers: Object.fromEntries(headers),
  });
};

type Icons8IllustrationDataParam = {
  id: string;
  fields?: string;
};

export type Icons8IllustrationByIdResponse = {
  styles: string[];
};

/**
 * Fetch Icons8 Illustrations of specified style and category
 *
 * @param param
 * @param token
 * @returns
 */
export const getIcons8IllustrationById = async (param: Icons8IllustrationDataParam, token: string) => {
  const { id, fields } = param;
  let requestURL = `${API_DOMAIN}/getIcons8IllustrationById`;
  const headers = new Headers({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  });

  return await request<Icons8IllustrationByIdResponse>(requestURL, {
    method: 'POST',
    headers: Object.fromEntries(headers),
    body: JSON.stringify({ id, fields }),
  });
};
